<template>
    <div>
        <vx-card title="Association" subtitle="Lists of Associations"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewAssociation()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeAssociation">
                    <template slot="thead">
                        <vs-th>Association</vs-th>
                        <vs-th>Start Date</vs-th>
                        <vs-th>End Date</vs-th>
                        <vs-th>Position</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].associationId">
                                {{ associationName(data[indextr].associationId).associationName }}
                            </vs-td>
                            <vs-td :data="data[indextr].dateStart">
                                {{data[indextr].dateStart | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].dateEnd">
                                {{data[indextr].dateEnd | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].position">
                                {{data[indextr].position}}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{data[indextr].remarks}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD ASSOCIATION -->
            <vs-prompt
                class="email-compose"
                title="Association"
                accept-text= "Submit"
                @accept="onAddAssociation"
                :is-valid="validForm"
                :active.sync="activePromptNewAssociation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Association Type</span><span style="color:red">*</span>
                        <v-select name="association-name" v-model="association" label="associationName" :options="getAssociationLookup" />

                    </div>
                </div>
              
                <div class="vx-row mb-3">
                   <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                        <flat-pickr  v-model="startDate" placeholder="Select Date" class="w-full" :disabledDates="disabledDatesFrom" :config="configFromdateTimePicker"  v-validate="'required'" @on-change="onFromChange"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">End Date</span>
                        <flat-pickr  v-model="endDate" placeholder="Select Date" class="w-full" :disabledDates="disabledDatesTo" :config="configTodateTimePicker"  v-validate="'required'" @on-change="onToChange"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2" >
                        <span  class="text-sm">Position</span>
                        <vs-input name="cert-name" class="w-full" v-model="position" placeholder="Position"/>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT ASSOCIATION -->
            <vs-prompt
                class="email-compose"
                title="Association"
                accept-text= "Submit"
                @accept="onEditAssociation"
                :is-valid="validForm"
                :active.sync="activePromptEditAssociation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Association Type</span><span style="color:red">*</span>
                        <v-select name="association-name" v-model="association" label="associationName" :options="getAssociationLookup"/>

                    </div>
                </div>
               <div class="vx-row mb-3">
                   <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                        <flat-pickr  v-model="startDate" placeholder="Select Date" class="w-full" :disabledDates="disabledDatesFrom" :config="configFromdateTimePicker"  v-validate="'required'" @on-change="onFromChange"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">End Date</span>
                        <flat-pickr  v-model="endDate" placeholder="Select Date" class="w-full" :disabledDates="disabledDatesTo" :config="configTodateTimePicker"  v-validate="'required'" @on-change="onToChange"/>

                    </div>
                </div>
                <!-- <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                        <flat-pickr :config="configFromdateTimePicker" :format="format" v-model="startDate" placeholder="Select Date" @on-change="onFromChange"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">End Date</span>
                        <flat-pickr :config="configTodateTimePicker" :format="format" v-model="endDate" placeholder="Select Date" @on-change="onToChange"/>

                    </div>
                </div> -->
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2" >
                        <span  class="text-sm">Position</span>
                        <vs-input name="cert-name" class="w-full" v-model="position" placeholder="Position"/>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            association         : [],
            issuedBy            : '',
            startDate           : null,
            position            : '',
            endDate             : null,
            remarks             : '',
            userId              : null,

            configFromdateTimePicker: {
              enableTime: false,
              maxDate: null
            },
            configTodateTimePicker: {
              enableTime: false,
            },

            uid                 : null,
            activePromptNewAssociation    : false,
            activePromptEditAssociation    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            // this.$store.dispatch('hrms/getAllAssociation', { userId : null})
            this.$store.dispatch('lookup/getAllAssociationLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeAssociation = this.uid
            //  this.$store.dispatch('hrms/getAllAssociation',  this.uid )
            
    },
    computed: {
        employeeAssociation: {
           
           get() { return this.$store.state.hrms.employeeAssociation },
           set(value) { this.$store.dispatch('hrms/getAllAssociation',  value )}
            
        },
        validForm(){
            return this.association != null && this.startDate !=null
        },
        getAssociationLookup() {
            return this.$store.state.lookup.getAllAssociationLookup
        },
        getRank() {
             return this.$store.state.lookup.getAllRankLookup
        },
        associationName() {
            return (id) => this.$store.getters['lookup/associationLookup'](id)
        },
        disabledDatesTo() {
            return { to: new Date(this.startDate) }
        },
        disabledDatesFrom() {
            return { from: new Date(this.endDate) }
        },
    },
    methods: {
        promptAddNewAssociation() {
            this.activePromptNewAssociation = true
        },
        onAddAssociation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    associationid: this.association.associationId,
                    dateStart: this.startDate,
                    position: this.position,
                    dateEnd: this.endDate,
                    remarks: this.remarks,
                    userId: this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                
                this.$store.dispatch('hrms/AddAssociation', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accredition Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
            }
            })
        },
        onEditAssociation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id               : this.id,
                    associationId    : this.association.associationId,
                    dateStart        : this.startDate,
                    position         : this.position,
                    dateEnd          : this.endDate,
                    remarks          : this.remarks,
                    userId           : this.uid,
                    currentUserId    : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateAssociation', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Association Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeAssociation'](Id)
            this.id = e.id,
            this.association = this.associationName(e.associationId),
            this.startDate = e.dateStart,
            this.position = e.position,
            this.endDate = e.dateEnd,
            this.remarks = e.remarks
            this.userId = e.userId

            this.activePromptEditAssociation = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteAssociation', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeAssociation = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Association Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    onFromChange(selectedDates, dateStr, instance) {
        this.$set(this.configTodateTimePicker, 'minDate', dateStr);
      },
    onToChange(selectedDates, dateStr, instance) {
        this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>